export const variables = {
	api_baseurl: import.meta.env.VITE_SMARTGIS_API_BASEURL,
	blob_baseurl: import.meta.env.VITE_BLOB_BASEURL
};
